import React from 'react';
import FormContainer from "../../../Inspection/components/FormContainer";
import InspectionOtherForm from "../InspectionOtherForm";
import {InspectionOtherUIProvider} from "../InspectionOtherUIContext";


const InspectionOtherPage = ({
                               cities,
                               streets,
                               updateStreets
                             }) => {
  return (
    <FormContainer>
        <InspectionOtherUIProvider
          cities={cities}
          streets={streets}
          updateStreets={updateStreets}
        >
          <InspectionOtherForm/>
        </InspectionOtherUIProvider>
    </FormContainer>
  );
};

export default InspectionOtherPage;

